// export this package's api
import Drawer from './Drawer';

export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-drawer/es/index.js
// module id = 1420
// module chunks = 0